import { getUser } from '../utils/paths';
import aiNativeBehaviorEvaluator from './aiNativeBehaviorEvaluator';

/**
 * Web-native aiDocumentParseBehavior: calls AI agents/order-parse with
 * documentKeys; customer from current user. Schema/prompt are owned by the AI
 * service. Same contract as server aiDocumentParseBehavior.
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const documentKeys = sourceEvaluator ? await sourceEvaluator(source.documentKeys) : source.documentKeys;
  const {
    customer
  } = getUser();
  if (!customer) {
    throw new Error('Customer is required for document parse');
  }
  return aiNativeBehaviorEvaluator.documentParse(customer, documentKeys);
};
export default {
  evaluate
};